<template>
    <div class="flex flex-col dark:text-white">
        <h3 class="my-2 text-base font-semibold text-gray-700 dark:text-gray-200">
            Pedido
        </h3>
        <div
            class="border border-black/5 dark:border-white/10 min-w-0 w-full rounded-xl overflow-hidden bg-white dark:bg-white/[0.02] mb-4 shadow-xs p-5"
        >
            <div class="grid grid-cols-3 gap-3">
                <div class="flex flex-col">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Número</span
                    >
                    <span
                        class="text-gray-800 dark:text-gray-200"
                        v-if="order"
                        >#{{ order.id }}</span
                    >
                </div>
                <div class="flex flex-col">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Código</span
                    >
                    <span
                        class="text-gray-800 dark:text-gray-200"
                        v-if="order"
                        >{{ order.order_hash }}</span
                    >
                </div>
                <div class="flex flex-col">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Valor do Pedido</span
                    >
                    <span
                        class="text-gray-800 dark:text-gray-200"
                        v-if="order"
                        >{{ $root.formatCurrency(order.amount + order.amount_card2) }}</span
                    >
                </div>
                <div class="flex flex-col">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Dois Cartões</span
                    >

                    <info-col v-if="order">
                        <CheckCircleIcon class="h-4 w-4 text-emerald-500" aria-hidden="true" v-if="order.is_two_cards" />
                        <XCircleIcon class="h-4 w-4 text-gray-400 dark:text-gray-500" aria-hidden="true" v-if="!order.is_two_cards" />
                    </info-col>
                </div>
                <div class="flex flex-col">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Boleto Parcelado</span
                    >

                    <info-col v-if="order">
                        <CheckCircleIcon class="h-4 w-4 text-emerald-500" aria-hidden="true" v-if="order.has_bank_slip_installment" />
                        <XCircleIcon class="h-4 w-4 text-gray-400 dark:text-gray-500" aria-hidden="true" v-if="!order.has_bank_slip_installment" />
                    </info-col>
                </div>
                <div class="flex flex-col">
                      <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Parcelamento Inteligente</span
                    >

                    <info-col v-if="order">
                        <CheckCircleIcon class="h-4 w-4 text-emerald-500" aria-hidden="true" v-if="order.has_smart_installment" />
                        <XCircleIcon class="h-4 w-4 text-gray-400 dark:text-gray-500" aria-hidden="true" v-if="!order.has_smart_installment" />
                    </info-col>
                </div>
                <div class="flex flex-col">
                      <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Upsell</span
                    >

                    <info-col v-if="order">
                        <CheckCircleIcon class="h-4 w-4 text-emerald-500" aria-hidden="true" v-if="order.is_upsell" />
                        <XCircleIcon class="h-4 w-4 text-gray-400 dark:text-gray-500" aria-hidden="true" v-if="!order.is_upsell" />
                    </info-col>
                </div>
                <div class="flex flex-col">
                      <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Possui Order Bump</span
                    >

                    <info-col v-if="order">
                        <CheckCircleIcon class="h-4 w-4 text-emerald-500" aria-hidden="true" v-if="order.has_order_bump" />
                        <XCircleIcon class="h-4 w-4 text-gray-400 dark:text-gray-500" aria-hidden="true" v-if="!order.has_order_bump" />
                    </info-col>
                </div>
                <div class="flex flex-col">
                      <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Possui Assinatura</span
                    >

                    <info-col v-if="order">
                        <CheckCircleIcon class="h-4 w-4 text-emerald-500" aria-hidden="true" v-if="order.has_subscription" />
                        <XCircleIcon class="h-4 w-4 text-gray-400 dark:text-gray-500" aria-hidden="true" v-if="!order.has_subscription" />
                    </info-col>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { CheckCircleIcon, XCircleIcon } from "@heroicons/vue/24/outline";
import HelperMixin from "../../mixins/HelperMixin.vue";

export default {
    components: {
        CheckCircleIcon,
        XCircleIcon,
    },
    props: ["order"],
    mixins: [HelperMixin],
    data() {
        return {
            loading: false,
            next_page_url: false,
            commissions: [],
            filters: {
                text: "",
                status: [],
                payment_method: [],
            },
        };
    },
};
</script>
